import { render, staticRenderFns } from "./transactionDetails.vue?vue&type=template&id=630c713a"
import script from "./transactionDetails.vue?vue&type=script&lang=js"
export * from "./transactionDetails.vue?vue&type=script&lang=js"
import style0 from "./transactionDetails.vue?vue&type=style&index=0&id=630c713a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports